import React, { useContext, useEffect, useState, memo } from "react";
import {
  FormControlLabel,
  IconButton,
  Tooltip,
  Card,
  CardContent,
  Divider,
  NativeSelect,
  CardHeader,
  Box,
  FormControl,
} from "@mui/material";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
} from "@mui/x-data-grid";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import UnarchiveIcon from "@mui/icons-material/Unarchive";
import uuid from "uuid";
import ArchiveIcon from "@mui/icons-material/Archive";
import { blue, purple } from "@mui/material/colors";
import { initialApplicantSource } from "../utils";
import DataContext from "../../context/DataContext";
import { useConfirm } from "material-ui-confirm";
import { useToasts } from "react-toast-notifications";
import { useRef } from "react";

function CustomToolbar() {
  return (
    <GridToolbarContainer>
      <GridToolbarExport printOptions={{ disableToolbarButton: true }} />
    </GridToolbarContainer>
  );
}

const PositionTable = memo(
  ({ setPositionform, setApplicantSource, positions, setPositionId }) => {
    // console.log("in position table");

    const confirm = useConfirm();
    const { addToast } = useToasts();

    useEffect(() => {
      // console.log("useEffect in positiontables");
    }, []);

    let {
      del,
      APIData,
      archivedPositions,
      setArchivedPositions,
      addObj,
      archivedClients,
      getArchivedClients,
      getArchivedPositions,
      clients,
    } = useContext(DataContext);

    let archivedColumns = [
      {
        field: "name",
        headerName: "Position",
        width: 130,
        type: "string",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.name}>
              <span>{params.row.name}</span>
            </Tooltip>
          );
        },
      },
      {
        field: "cost_per_hire",
        headerName: "Cost Per Hire",
        width: 110,
        type: "number",
        description: "Cost per hire",
        headerAlign: "center",
        align: "center",
      },
      {
        field: "conversion_rate",
        headerName: "Conversion Rate",
        width: 130,
        type: "number",
        description: "Conversion rate",
        headerAlign: "center",
        align: "center",
      },
      {
        field: "turnover_rate",
        headerName: "Turnover Rate",
        description: "Turnover rate",
        type: "number",
        width: 120,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "time_to_fill",
        headerName: "Time to Fill",
        description: "Time to fill",
        type: "number",
        width: 100,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "date_modified",
        headerName: "Last Modified",
        description: "Date since last modified",
        type: "dateTime",
        width: 160,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "client_name",
        headerName: "Client",
        description: "Client name",
        type: "string",
        width: 130,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.client_name}>
              <span>{params.row.client_name}</span>
            </Tooltip>
          );
        },
      },
    ];

    var actionFieldUnArchive = {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      width: 140,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const handleDeleteClick = () => {
          // console.log("deleting archived id:", params.row.id);
          confirm({
            description: `Are you sure you want to delete position ${params.row.name}?`,
          })
            .then(() => {
              addToast(`Position '${params.row.name}' deleted successfully`, {
                appearance: "success",
              });
              del(params.row.id, true);

              // APIData.delete(`/position/${params.row.id}/`)
              //   .then(() => {
              //     addToast(
              //       `Position '${params.row.name}' deleted successfully`,
              //       { appearance: "success" }
              //     );
              //     del(params.row.id, true);
              //   })
              //   .catch((error) => {
              //     addToast(error.message, { appearance: "error" });
              //     console.error(
              //       "Could not delete pos id:",
              //       params.row.id,
              //       error
              //     );
              //   });
            })
            .catch((rej) => {});
        };

        const handleUnarchiveClick = async () => {
          let item = archivedPositions.filter(
            (position) => position.id === params.row.id
          )[0];
          item["archived"] = false;
          // console.log(archivedClients);
          // console.log(params.row);

          let cli = clients.filter((client) => client.id === params.row.client);

          if (cli.length > 0) {
            var pos = archivedPositions.filter(
              (position) => position.id === params.row.id
            )[0];

            addToast(`Position '${params.row.name}' unarchived successfully`, {
              appearance: "success",
            });
            del(params.row.id, true); //delete from archived positions
            addObj(pos); //add to positions

            // APIData.patch(`/position/${params.row.id}/`, item)
            //   .then((res) => {
            //     addToast(
            //       `Position '${params.row.name}' unarchived successfully`,
            //       { appearance: "success" }
            //     );
            //     del(params.row.id, true); //delete from archived positions
            //     addObj(res.data); //add to positions
            //   })
            //   .catch((error) => {
            //     addToast(error.message, { appearance: "error" });
            //     console.error("could not un archive position", error);
            //   });
          } else {
            addToast(
              `Cannot unarchive position '${params.row.name}'. Position's client must be unarchived.`,
              {
                appearance: "error",
              }
            );
          }
        };

        return (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
          >
            <div>
              {/* <Tooltip title="Edit">
                <IconButton color="secondary" onClick={handleEditClick}>
                  <EditIcon style={{ color: blue[500] }} />
                </IconButton>
              </Tooltip> */}
              <Tooltip title="Unarchive">
                <IconButton color="secondary" onClick={handleUnarchiveClick}>
                  <UnarchiveIcon style={{ color: purple[500] }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton color="secondary" onClick={handleDeleteClick}>
                  <DeleteIcon style={{ color: blue[500] }} />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        );
      },
    };

    archivedColumns.push(actionFieldUnArchive);

    let columns = [
      {
        field: "name",
        headerName: "Position",
        // width: 130,
        flex: 1,
        type: "string",
        headerAlign: "center",
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.name}>
              <span>{params.row.name}</span>
            </Tooltip>
          );
        },
      },
      {
        field: "cost_per_hire",
        headerName: "Cost Per Hire",
        // width: 110,
        flex: 1,
        type: "number",
        description: "Cost per hire",
        headerAlign: "center",
        align: "center",
      },
      {
        field: "conversion_rate",
        headerName: "Conversion Rate",
        // width: 130,
        flex: 1,
        type: "number",
        description: "Conversion rate",
        headerAlign: "center",
        align: "center",
      },
      {
        field: "turnover_rate",
        headerName: "Turnover Rate",
        description: "Turnover rate",
        type: "number",
        // width: 120,
        flex: 1,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "time_to_fill",
        headerName: "Time to Fill",
        description: "Time to fill",
        type: "number",
        // width: 100,
        flex: 1,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "date_modified",
        headerName: "Last Modified",
        description: "Date since last modified",
        type: "dateTime",
        // width: 160,
        flex: 1,
        headerAlign: "center",
        align: "center",
      },
      {
        field: "client_name",
        headerName: "Client",
        description: "Client name",
        type: "string",
        // width: 130,
        flex: 1,
        headerAlign: "center",
        align: "center",
        renderCell: (params) => {
          return (
            <Tooltip title={params.row.client_name}>
              <span>{params.row.client_name}</span>
            </Tooltip>
          );
        },
      },
    ];

    var actionFieldArchive = {
      field: "actions",
      headerName: "Actions",
      sortable: false,
      width: 120,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        const handleEditClickmain = () => {
          let item = positions.filter(
            (position) => position.id === params.row.id
          )[0];

          //the update fuction from datacontext gets called in positionform.js)
          setPositionform({
            name: item.name,
            cost_per_hire: item.cost_per_hire,
            conversion_rate: item.conversion_rate,
            turnover_rate: item.turnover_rate,
            time_to_fill: item.time_to_fill,
            client: item.client,
            avg_time_to_hire: item.avg_time_to_hire,
            vacancies: item.vacancies,
            applications: item.applications,
            interviews: item.interviews,
            assessments: item.assessments,
            hires: item.hires,
          });

          setPositionId(item.id);
          setApplicantSource(item.applicant_source);
        };

        const handleDeleteClickmain = () => {
          confirm({
            description: `Are you sure you want to delete position ${params.row.name}?`,
          })
            .then(() => {
              addToast(`Position '${params.row.name}' deleted successfully`, {
                appearance: "success",
              });
              del(params.row.id);

              // APIData.delete(`/position/${params.row.id}/`)
              //   .then(() => {
              //     addToast(
              //       `Position '${params.row.name}' deleted successfully`,
              //       { appearance: "success" }
              //     );
              //     del(params.row.id);
              //   })
              //   .catch((error) => {
              //     addToast(error.message, { appearance: "error" });
              //     console.error(
              //       "Could not delete pos id:",
              //       params.row.id,
              //       error
              //     );
              //   });
            })
            .catch((rej) => {});
        };

        //Because we are not using redux, more jankyiness
        const handleArchiveClickmain = async () => {
          let item = positions.filter(
            (position) => position.id === params.row.id
          )[0];
          item["archived"] = true;

          del(params.row.id); //delete from positions

          addToast(`Position '${params.row.name}' archived successfully`, {
            appearance: "success",
          });
          setArchivedPositions([
            //add to archived positions
            ...archivedPositions,
            params.row,
          ]);

          // APIData.patch(`/position/${params.row.id}/`, item)
          //   .then((res) => {
          //     del(params.row.id); //delete from positions

          //     addToast(`Position '${params.row.name}' archived successfully`, {
          //       appearance: "success",
          //     });
          //     setArchivedPositions([
          //       //add to archived positions
          //       ...archivedPositions,
          //       params.row,
          //     ]);
          //   })
          //   .catch((error) => {
          //     addToast(error.message, { appearance: "error" });
          //     console.error("could not patch position:", error);
          //   });
        };

        return (
          <div
            className="d-flex justify-content-between align-items-center"
            style={{ cursor: "pointer" }}
          >
            <div>
              <Tooltip title="Edit">
                <IconButton color="secondary" onClick={handleEditClickmain}>
                  <EditIcon style={{ color: blue[500] }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Archive">
                <IconButton color="secondary" onClick={handleArchiveClickmain}>
                  <ArchiveIcon style={{ color: blue[500] }} />
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete">
                <IconButton color="secondary" onClick={handleDeleteClickmain}>
                  <DeleteIcon style={{ color: blue[500] }} />
                </IconButton>
              </Tooltip>
            </div>
          </div>
        );
      },
    };
    // const columns = structuredClone(archivedColumns);
    columns.push(actionFieldArchive);

    const [subChart, setSubChart] = useState("most-important");

    var firstClick = useRef(true); //resplace with useRef??

    const handleChange = (value) => {
      // if (firstClick.current) {
      //   //call APIData
      //   getArchivedPositions();

      //   firstClick.current = false;
      //   getArchivedClients();

      //   // get data for client as well, because we need to unarchiving an pos with an archived client
      //   // should prevent reload of client data twice
      // }
      setSubChart(value);
    };

    return (
      <Card>
        <CardHeader
          action={
            <Box sx={{ mr: 2 }}>
              <FormControl fullWidth color="secondary">
                <NativeSelect
                  defaultValue={"most-important"}
                  onChange={(e) => handleChange(e.target.value)}
                >
                  <option value={"most-important"}>Positions</option>
                  <option value={"overview"}>Archived</option>
                </NativeSelect>
              </FormControl>
            </Box>
          }
          titleTypographyProps={{ variant: "h6" }}
          title="Position Data"
        />
        <Divider />
        <CardContent>
          <div style={{ height: 600, width: "100%" }}>
            {subChart === "most-important" ? (
              <DataGrid
                disableSelectionOnClick
                rows={positions}
                columns={columns}
                pageSize={20}
                rowsPerPageOptions={[20]}
                components={{
                  Toolbar: CustomToolbar,
                }}
              />
            ) : (
              <DataGrid
                disableSelectionOnClick
                rows={archivedPositions}
                columns={archivedColumns}
                components={{
                  Toolbar: CustomToolbar,
                }}
                pageSize={20}
                rowsPerPageOptions={[20]}
              />
            )}
          </div>
        </CardContent>
      </Card>
    );
  }
);

export { PositionTable };
